import axios from 'axios'
import { authHeader } from '../_helpers'
import { cancelSource } from '../_helpers/cancelToken'

const state = {
  transactions: [],
  noSuspectTransactions: [],
  marks: [],
  suspectTransactions: [],
  dayStatusTransactions: [],
  reportTransactions: [],
  transactionsLoading: false,
  dayAndStatusLoading: false,
  upload: false,
  autographReportData: []
}

const actions = {
  clearData ({ commit }) {
    commit('clear')
  },
  getOpti24Transaction ({ dispatch, commit }, date) {
    dispatch('alert/clear', null, { root: true })
    cancelSource.cancel()
    cancelSource.setSource(axios.CancelToken.source())
    dispatch('users/getUserInfo', JSON.parse(localStorage.getItem('user')).id, { root: true })
    commit('startTransactionsLoading')
    // Отправить запрос get
    axios.get(process.env.VUE_APP_URL + '/transactions/api/Opti24Transaction?month=' + (date.getMonth() + 1) + '&year=' + date.getFullYear(), { headers: authHeader(), cancelToken: cancelSource.getSource().token })
      .then(responce => {
        commit('transactionsLoadSuccess', responce.data)
        commit('endTransactionsLoading')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        var errorCode = error.response.status
        switch (errorCode) {
          case 400:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
        commit('transactionsLoadFailed', error)
        commit('endTransactionsLoading')
      })
    // Обработать с помощью базовых мутаций.
    return null
  },
  getShellTransaction ({ dispatch, commit }, date) {
    dispatch('alert/clear', null, { root: true })
    cancelSource.cancel()
    cancelSource.setSource(axios.CancelToken.source())
    dispatch('users/getUserInfo', JSON.parse(localStorage.getItem('user')).id, { root: true })
    commit('startTransactionsLoading')
    // Отправить запрос get
    axios.get(process.env.VUE_APP_URL + '/transactions/api/ShellTransaction?month=' + (date.getMonth() + 1) + '&year=' + date.getFullYear(), { headers: authHeader(), cancelToken: cancelSource.getSource().token })
      .then(responce => {
        commit('transactionsLoadSuccess', responce.data)
        commit('endTransactionsLoading')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        var errorCode = error.response.status
        switch (errorCode) {
          case 400:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
        commit('transactionsLoadFailed', error)
        commit('endTransactionsLoading')
      })
    // Обработать с помощью базовых мутаций.
    return null
  },
  getNesteTransaction ({ dispatch, commit }, date) {
    dispatch('alert/clear', null, { root: true })
    cancelSource.cancel()
    cancelSource.setSource(axios.CancelToken.source())
    dispatch('users/getUserInfo', JSON.parse(localStorage.getItem('user')).id, { root: true })
    commit('startTransactionsLoading')
    // Отправить запрос get
    axios.get(process.env.VUE_APP_URL + '/transactions/api/NesteTransaction?month=' + (date.getMonth() + 1) + '&year=' + date.getFullYear(), { headers: authHeader(), cancelToken: cancelSource.getSource().token })
      .then(responce => {
        commit('transactionsLoadSuccess', responce.data)
        commit('endTransactionsLoading')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        var errorCode = error.response.status
        switch (errorCode) {
          case 400:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
        commit('transactionsLoadFailed', error)
        commit('endTransactionsLoading')
      })
    // Обработать с помощью базовых мутаций.
    return null
  },
  getRosneftTransaction ({ dispatch, commit }, date) {
    dispatch('alert/clear', null, { root: true })
    cancelSource.cancel()
    cancelSource.setSource(axios.CancelToken.source())
    dispatch('users/getUserInfo', JSON.parse(localStorage.getItem('user')).id, { root: true })
    commit('startTransactionsLoading')
    // Отправить запрос get
    axios.get(process.env.VUE_APP_URL + '/transactions/api/RosneftTransaction?month=' + (date.getMonth() + 1) + '&year=' + date.getFullYear(), { headers: authHeader(), cancelToken: cancelSource.getSource().token })
      .then(responce => {
        commit('transactionsLoadSuccess', responce.data)
        commit('endTransactionsLoading')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        var errorCode = error.response.status
        switch (errorCode) {
          case 400:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
        commit('transactionsLoadFailed', error)
        commit('endTransactionsLoading')
      })
    // Обработать с помощью базовых мутаций.
    return null
  },
  getPetrolReport ({ dispatch, commit }, { startDate, endDate, token }) {
    dispatch('alert/clear', null, { root: true })
    cancelSource.cancel()
    cancelSource.setSource(axios.CancelToken.source())
    commit('startTransactionsLoading')
    dispatch('users/getUserInfo', JSON.parse(localStorage.getItem('user')).id, { root: true })
    const requestData = {
      Token: token,
      StartDate: startDate,
      EndDate: endDate
    }
    axios.post(process.env.VUE_APP_URL + 'transactions/petrol', requestData, { headers: authHeader(), cancelToken: cancelSource.getSource().token })
      .then(responce => {
        commit('petrolReportSuccess', responce.data)
        commit('endTransactionsLoading')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        commit('transactionsLoadFailed', error)
        commit('endTransactionsLoading')
        var errorCode = error.response.status
        switch (errorCode) {
          case 400:
            dispatch('alert/info', 'Информация: ' + 'Проверьте токен доступа системы топливных карт (Для системы ППР)', { root: true })
            break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
      })
  },
  getOpti24Report ({ dispatch, commit }, { startDate, endDate }) {
    dispatch('alert/clear', null, { root: true })
    cancelSource.cancel()
    cancelSource.setSource(axios.CancelToken.source())
    commit('startTransactionsLoading')
    dispatch('users/getUserInfo', JSON.parse(localStorage.getItem('user')).id, { root: true })
    const requestData = {
      StartDate: startDate,
      EndDate: endDate
    }
    axios.post(process.env.VUE_APP_URL + '/transactions/api/Opti24Transaction/Report', requestData, { headers: authHeader(), cancelToken: cancelSource.getSource().token })
      .then(responce => {
        commit('petrolReportSuccess', responce.data)
        commit('endTransactionsLoading')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        commit('transactionsLoadFailed', error)
        commit('endTransactionsLoading')
        var errorCode = error.response.status
        switch (errorCode) {
          case 400:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
      })
  },
  getShellReport ({ dispatch, commit }, { startDate, endDate }) {
    dispatch('alert/clear', null, { root: true })
    cancelSource.cancel()
    cancelSource.setSource(axios.CancelToken.source())
    commit('startTransactionsLoading')
    dispatch('users/getUserInfo', JSON.parse(localStorage.getItem('user')).id, { root: true })
    const requestData = {
      StartDate: startDate,
      EndDate: endDate
    }
    axios.post(process.env.VUE_APP_URL + '/transactions/api/ShellTransaction/Report', requestData, { headers: authHeader(), cancelToken: cancelSource.getSource().token })
      .then(responce => {
        commit('petrolReportSuccess', responce.data)
        commit('endTransactionsLoading')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        commit('transactionsLoadFailed', error)
        commit('endTransactionsLoading')
        var errorCode = error.response.status
        switch (errorCode) {
          case 400:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
      })
  },
  getNesteReport ({ dispatch, commit }, { startDate, endDate }) {
    dispatch('alert/clear', null, { root: true })
    cancelSource.cancel()
    cancelSource.setSource(axios.CancelToken.source())
    commit('startTransactionsLoading')
    dispatch('users/getUserInfo', JSON.parse(localStorage.getItem('user')).id, { root: true })
    const requestData = {
      StartDate: startDate,
      EndDate: endDate
    }
    axios.post(process.env.VUE_APP_URL + '/transactions/api/NesteTransaction/Report', requestData, { headers: authHeader(), cancelToken: cancelSource.getSource().token })
      .then(responce => {
        commit('petrolReportSuccess', responce.data)
        commit('endTransactionsLoading')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        commit('transactionsLoadFailed', error)
        commit('endTransactionsLoading')
        var errorCode = error.response.status
        switch (errorCode) {
          case 400:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
      })
  },
  getRosneftReport ({ dispatch, commit }, { startDate, endDate }) {
    dispatch('alert/clear', null, { root: true })
    cancelSource.cancel()
    cancelSource.setSource(axios.CancelToken.source())
    commit('startTransactionsLoading')
    dispatch('users/getUserInfo', JSON.parse(localStorage.getItem('user')).id, { root: true })
    const requestData = {
      StartDate: startDate,
      EndDate: endDate
    }
    axios.post(process.env.VUE_APP_URL + '/transactions/api/RosneftTransaction/Report', requestData, { headers: authHeader(), cancelToken: cancelSource.getSource().token })
      .then(responce => {
        commit('petrolReportSuccess', responce.data)
        commit('endTransactionsLoading')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        commit('transactionsLoadFailed', error)
        commit('endTransactionsLoading')
        var errorCode = error.response.status
        switch (errorCode) {
          case 400:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
      })
  },
  getAutographOpti24Report ({ dispatch, commit }, { startDate, endDate, schemaId, interval }) {
    dispatch('alert/clear', null, { root: true })
    cancelSource.cancel()
    cancelSource.setSource(axios.CancelToken.source())
    commit('startTransactionsLoading')
    dispatch('users/getUserInfo', JSON.parse(localStorage.getItem('user')).id, { root: true })
    const requestData = {
      StartDate: startDate,
      EndDate: endDate,
      SchemaId: schemaId,
      interval: interval
    }
    axios.post(process.env.VUE_APP_URL + '/transactions/api/autographReport/Opti24', requestData, { headers: authHeader(), cancelToken: cancelSource.getSource().token })
      .then(responce => {
        if (responce.data.length > 0) { commit('AutographReportSuccess', responce.data) } else { dispatch('alert/warning', 'Отсутствуют данные за указаный период.', { root: true }) }
        commit('endTransactionsLoading')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        commit('endTransactionsLoading')
        var errorCode = error.response.status
        switch (errorCode) {
          case 400:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
      })
  },
  getAutographPetrolReport ({ dispatch, commit }, { startDate, endDate, schemaId, interval }) {
    dispatch('alert/clear', null, { root: true })
    cancelSource.cancel()
    cancelSource.setSource(axios.CancelToken.source())
    commit('startTransactionsLoading')
    dispatch('users/getUserInfo', JSON.parse(localStorage.getItem('user')).id, { root: true })
    const requestData = {
      StartDate: startDate,
      EndDate: endDate,
      SchemaId: schemaId,
      interval: interval
    }
    axios.post(process.env.VUE_APP_URL + '/transactions/api/autographReport/Petrol', requestData, { headers: authHeader(), cancelToken: cancelSource.getSource().token })
      .then(responce => {
        if (responce.data.length > 0) { commit('AutographReportSuccess', responce.data) } else { dispatch('alert/warning', 'Отсутствуют данные за указаный период.', { root: true }) }
        commit('endTransactionsLoading')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        commit('endTransactionsLoading')
        var errorCode = error.response.status
        switch (errorCode) {
          case 400:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
      })
  },
  getAutographShellReport ({ dispatch, commit }, { startDate, endDate, schemaId, interval }) {
    dispatch('alert/clear', null, { root: true })
    cancelSource.cancel()
    cancelSource.setSource(axios.CancelToken.source())
    commit('startTransactionsLoading')
    dispatch('users/getUserInfo', JSON.parse(localStorage.getItem('user')).id, { root: true })
    const requestData = {
      StartDate: startDate,
      EndDate: endDate,
      SchemaId: schemaId,
      interval: interval
    }
    axios.post(process.env.VUE_APP_URL + '/transactions/api/autographReport/Shell', requestData, { headers: authHeader(), cancelToken: cancelSource.getSource().token })
      .then(responce => {
        if (responce.data.length > 0) { commit('AutographReportSuccess', responce.data) } else { dispatch('alert/warning', 'Отсутствуют данные за указаный период.', { root: true }) }
        commit('endTransactionsLoading')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        commit('endTransactionsLoading')
        var errorCode = error.response.status
        switch (errorCode) {
          case 400:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
      })
  },
  getAutographNesteReport ({ dispatch, commit }, { startDate, endDate, schemaId, interval }) {
    dispatch('alert/clear', null, { root: true })
    cancelSource.cancel()
    cancelSource.setSource(axios.CancelToken.source())
    commit('startTransactionsLoading')
    dispatch('users/getUserInfo', JSON.parse(localStorage.getItem('user')).id, { root: true })
    const requestData = {
      StartDate: startDate,
      EndDate: endDate,
      SchemaId: schemaId,
      interval: interval
    }
    axios.post(process.env.VUE_APP_URL + '/transactions/api/autographReport/Neste', requestData, { headers: authHeader(), cancelToken: cancelSource.getSource().token })
      .then(responce => {
        if (responce.data.length > 0) { commit('AutographReportSuccess', responce.data) } else { dispatch('alert/warning', 'Отсутствуют данные за указаный период.', { root: true }) }
        commit('endTransactionsLoading')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        commit('endTransactionsLoading')
        var errorCode = error.response.status
        switch (errorCode) {
          case 400:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
      })
  },
  getAutographRosneftReport ({ dispatch, commit }, { startDate, endDate, schemaId, interval }) {
    dispatch('alert/clear', null, { root: true })
    cancelSource.cancel()
    cancelSource.setSource(axios.CancelToken.source())
    commit('startTransactionsLoading')
    dispatch('users/getUserInfo', JSON.parse(localStorage.getItem('user')).id, { root: true })
    const requestData = {
      StartDate: startDate,
      EndDate: endDate,
      SchemaId: schemaId,
      interval: interval
    }
    axios.post(process.env.VUE_APP_URL + '/transactions/api/autographReport/Rosneft', requestData, { headers: authHeader(), cancelToken: cancelSource.getSource().token })
      .then(responce => {
        if (responce.data.length > 0) { commit('AutographReportSuccess', responce.data) } else { dispatch('alert/warning', 'Отсутствуют данные за указаный период.', { root: true }) }
        commit('endTransactionsLoading')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        commit('endTransactionsLoading')
        var errorCode = error.response.status
        switch (errorCode) {
          case 400:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
      })
  },
  getPetrolTransactions ({ dispatch, commit, rootState }, { date, token }) {
    dispatch('alert/clear', null, { root: true })
    cancelSource.cancel()
    cancelSource.setSource(axios.CancelToken.source())
    dispatch('users/getUserInfo', JSON.parse(localStorage.getItem('user')).id, { root: true })
    if (token) {
      commit('startTransactionsLoading')
      axios.get(process.env.VUE_APP_URL + '/transactions/petrol/ByDate?month=' + (date.getMonth() + 1) + '&year=' + date.getFullYear() + '&token=' + token, { headers: authHeader(), cancelToken: cancelSource.getSource().token })
        .then(responce => {
          commit('transactionsLoadSuccess', responce.data)
          commit('endTransactionsLoading')
        })
        .catch(error => {
          if (axios.isCancel(error)) {
            return
          }
          // DGTgaaGbTbEvCFygnFuLXXHXXdxcLGUR
          var errorCode = error.response.status
          switch (errorCode) {
            case 400:
              dispatch('alert/info', 'Информация: ' + 'Проверьте токен доступа системы топливных карт (Для системы ППР)', { root: true })
              break
            case 401:
              dispatch('account/logout', {}, { root: true })
              return
            default:
              dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
              break
          }
          commit('transactionsLoadFailed', error)
          commit('endTransactionsLoading')
        })
    } else {
      commit('transactionsLoadFailed')
      dispatch('alert/warning', 'Для загрузки аналитики укажите токен в профиле пользователя', { root: true })
    }
  },
  getTransactionsByDayAndStatus ({ dispatch, commit }, { date, isSuspect }) {
    dispatch('alert/clear', null, { root: true })
    if (state.transactions) {
      commit('startDayAndStatusLoading')
      commit('TransactionsByDayAndStatusSuccess', { date: date, suspect: isSuspect })
      commit('endDayAndStatusLoading')
    } else {
      commit('TransactionsByDayAndStatusFailed')
      commit('endDayAndStatusLoading')
      dispatch('alert/error', 'Нет данных для текущей выборки', { root: true })
    }
  },
  uploadOpti24TransactionToServer ({ dispatch, commit }, files) {
    dispatch('alert/clear', null, { root: true })
    commit('uploadStart')
    const headers = authHeader()
    // eslint-disable-next-line prefer-const
    let fd = new FormData()
    fd.append('file', files)
    headers['Content-Type'] = 'multipart/form-data'
    axios.post(process.env.VUE_APP_URL + '/transactions/api/Opti24Transaction',
      fd,
      {
        headers: headers
      })
      .then(responce => {
        dispatch('alert/success', 'Отчет успешно загружен в систему. Данные обновлены.', { root: true })
        commit('uploadEnd')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        // DGTgaaGbTbEvCFygnFuLXXHXXdxcLGUR
        var errorCode = error.response.status
        switch (errorCode) {
          case 400:
            dispatch('alert/error', 'Произошла ошибка во время загрузки файла. ', { root: true })
            break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
        commit('uploadEnd')
      })
  },
  uploadShellTransactionToServer ({ dispatch, commit }, files) {
    dispatch('alert/clear', null, { root: true })
    commit('uploadStart')
    const headers = authHeader()
    // eslint-disable-next-line prefer-const
    let fd = new FormData()
    fd.append('file', files)
    headers['Content-Type'] = 'multipart/form-data'
    axios.post(process.env.VUE_APP_URL + '/transactions/api/ShellTransaction',
      fd,
      {
        headers: headers
      })
      .then(responce => {
        dispatch('alert/success', 'Отчет успешно загружен в систему. Данные обновлены.', { root: true })
        commit('uploadEnd')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        // DGTgaaGbTbEvCFygnFuLXXHXXdxcLGUR
        var errorCode = error.response.status
        switch (errorCode) {
          case 400:
            dispatch('alert/error', 'Произошла ошибка во время загрузки файла. ', { root: true })
            break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
        commit('uploadEnd')
      })
  },
  uploadNesteTransactionToServer ({ dispatch, commit }, files) {
    dispatch('alert/clear', null, { root: true })
    commit('uploadStart')
    const headers = authHeader()
    // eslint-disable-next-line prefer-const
    let fd = new FormData()
    fd.append('file', files)
    headers['Content-Type'] = 'multipart/form-data'
    axios.post(process.env.VUE_APP_URL + '/transactions/api/NesteTransaction',
      fd,
      {
        headers: headers
      })
      .then(responce => {
        dispatch('alert/success', 'Отчет успешно загружен в систему. Данные обновлены.', { root: true })
        commit('uploadEnd')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        // DGTgaaGbTbEvCFygnFuLXXHXXdxcLGUR
        var errorCode = error.response.status
        switch (errorCode) {
          case 400:
            dispatch('alert/error', 'Произошла ошибка во время загрузки файла. ', { root: true })
            break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
        commit('uploadEnd')
      })
  },
  uploadRosneftTransactionToServer ({ dispatch, commit }, files) {
    dispatch('alert/clear', null, { root: true })
    commit('uploadStart')
    const headers = authHeader()
    // eslint-disable-next-line prefer-const
    let fd = new FormData()
    fd.append('file', files)
    headers['Content-Type'] = 'multipart/form-data'
    axios.post(process.env.VUE_APP_URL + '/transactions/api/RosneftTransaction',
      fd,
      {
        headers: headers
      })
      .then(responce => {
        dispatch('alert/success', 'Отчет успешно загружен в систему. Данные обновлены.', { root: true })
        commit('uploadEnd')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        // DGTgaaGbTbEvCFygnFuLXXHXXdxcLGUR
        var errorCode = error.response.status
        switch (errorCode) {
          case 400:
            dispatch('alert/error', 'Произошла ошибка во время загрузки файла. ', { root: true })
            break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
        commit('uploadEnd')
      })
  }
}

const mutations = {
  clear (state) {
    state.dayStatusTransactions = []
    state.transactions = []
    state.noSuspectTransactions = []
    state.suspectTransactions = []
    state.marks = null
  },
  AutographReportSuccess (state, data) {
    state.autographReportData = data
  },
  uploadStart (state) {
    state.upload = true
  },
  uploadEnd (state) {
    state.upload = false
  },
  petrolReportSuccess (state, data) {
    state.reportTransactions = data
  },
  startDayAndStatusLoading (state) {
    state.dayAndStatusLoading = true
  },
  startTransactionsLoading (state) {
    state.dayStatusTransactions = []
    state.transactionsLoading = true
  },
  endTransactionsLoading (state) {
    state.transactionsLoading = false
  },
  endDayAndStatusLoading (state) {
    state.dayAndStatusLoading = false
  },
  TransactionsByDayAndStatusSuccess (state, result) {
    const day = result.date
    if (result.suspect) {
      state.dayStatusTransactions = state.suspectTransactions.filter(c => new Date(c.transactionDate).toDateString() === day.toDateString())
    } else {
      state.dayStatusTransactions = state.noSuspectTransactions.filter(c => new Date(c.transactionDate).toDateString() === day.toDateString())
    }
  },
  TransactionsByDayAndStatusFailed (state) {
    state.dayStatusTransactions = []
    state.transactions = []
    state.noSuspectTransactions = []
    state.suspectTransactions = []
  },
  transactionsLoadSuccess (state, transactions) {
    state.transactions = transactions
    const unqiueServiceType = []
    for (const str of transactions.map(c => c.serviceType)) {
      if (!unqiueServiceType.includes(str)) {
        unqiueServiceType.push(str)
      }
    }
    state.marks = unqiueServiceType
    state.suspectTransactions = transactions.filter(c => !isInRange(c.transactionDateTime))
    state.noSuspectTransactions = transactions.filter(c => isInRange(c.transactionDateTime))
  },
  transactionsLoadFailed (state) {
    state.dayStatusTransactions = []
    state.transactions = []
    state.noSuspectTransactions = []
    state.suspectTransactions = []
    state.marks = null
  }
}

function isInRange (date) {
  if (date !== undefined) {
    var currentDate = new Date(date)
    var startWorkTime = localStorage.getItem('StartDate')
    var endWorkTime = localStorage.getItem('EndDate')
    var timeStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), startWorkTime.slice(0, 2) * 1, startWorkTime.slice(3, 5) * 1)
    var timeEnd = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), endWorkTime.slice(0, 2) * 1, endWorkTime.slice(3, 5) * 1)
    return timeStart <= currentDate && currentDate <= timeEnd
  }
}

export const transactions = {
  namespaced: true,
  state,
  actions,
  mutations
}
